// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"4b6b6b3d","233":"2c82c1cf","328":"ead3a5f1","349":"f7c897c7","524":"747e34f3","525":"f56a2077","560":"0f2d6f5d","603":"5cf16357","820":"aa5fd307","957":"e727567d"}[chunkId] + ".chunk.js";
};